import { render, staticRenderFns } from "./beamoderator.vue?vue&type=template&id=45d5b5de&scoped=true&"
import script from "./beamoderator.vue?vue&type=script&lang=js&"
export * from "./beamoderator.vue?vue&type=script&lang=js&"
import style0 from "./beamoderator.vue?vue&type=style&index=0&id=45d5b5de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d5b5de",
  null
  
)

export default component.exports